/* eslint-disable react/display-name*/
import {
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import JournalEntryCrud from "./JournalEntryCrud";
import { StringUtils } from "../../../utils/StringUtils";
import GenericReportViewer from "./../../reports/GenericReportViewer";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function JournalEntryList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [showCrud, setShowCrud] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedJournal, setSelectedJournal] = useState(null);
  const [mode, setMode] = useState();
  const [viewOnlyForUpdate, setViewOnlyForUpdate] = useState(false);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 155) / 32)
  );

  useEffect(() => {
    loadData();
  }, []);

  function onEditClickedOrViewClicked(tableMeta) {
    setSelectedJournal(
      tableMeta.tableData[tableMeta.currentTableData[tableMeta.rowIndex].index]
        .id
    );
    setShowCrud(true);
    setMode(
      props.context.privileges.jv_update_update ||
        props.context.privileges.jv_update_delete
        ? "edit"
        : "view"
    );
  }

  async function loadData() {
    loadByRest(0, rowLimitPerPage, "[]", "[]");
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);
    sort = '[{id:"Date",desc:true}]';
    const result = await API.get(
      "/api/v1/accounting/adjustment" +
        "?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    opt.rowsPerPage = pageSize;
    setOption(opt);
    setData(processData(result.data));
    setIsLoading(false);
  }

  function processData(data) {
    data.forEach((item) => {
      let totalCredit = 0;
      let totalDebit = 0;
      item.entryList.forEach((entry) => {
        totalCredit += parseFloat(entry.creditAmount);
        totalDebit += parseFloat(entry.debitAmount);
      });
      item["totalCredit"] = totalCredit;
      item["totalDebit"] = totalDebit;
    });
    return data;
  }

  async function onTableChange(tableState) {
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"name",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"code",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"description",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"amount",value:"' + tableState.searchText + '"}';
      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, tableState.rowsPerPage, sort, search);
  }

  function onPrintClicked(row) {
    let paramsList = [
      {
        key: "transactionId",
        value: row.tableData[row.rowIndex].id,
      },
    ];

    biRef.genericReportView.showGenericReportViewer(
      "reports/generic/Journal_entry",
      paramsList,
      "Accounts Transaction"
    );
  }

  function addJournalEntryTransaction() {
    setShowCrud(true);
    setMode("create");
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    // search: true,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRowsHeader: false,
    rowsPerPage: rowLimitPerPage,
    tableBodyHeight: getWindowDimensions().height - 162,
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 162) / 33),
      10,
      15,
      50,
      100,
    ],
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want
      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="secondary"
              onClick={transactionsListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title={translate("Add New Journal Entry")}>
            <IconButton color="primary" onClick={addJournalEntryTransaction}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "code",
      label: translate("Code"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "date",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "totalCredit",
      label: translate("Total Credit"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "totalDebit",
      label: translate("Total Debit"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "description",
      label: translate("Description"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            {props.context.privileges.jv_update_update && (
              <Button
                onClick={() => {
                  onEditClickedOrViewClicked(tableMeta, updateValue, value);
                  setViewOnlyForUpdate(true);
                }}
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("View")}
              </Button>
            )}

            <Button
              onClick={() => {
                onEditClickedOrViewClicked(tableMeta, updateValue, value);
                setViewOnlyForUpdate(false);
              }}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {props.context.privileges.jv_update_update
                ? translate("Update")
                : translate("View")}
            </Button>
            <Button
              onClick={() => onPrintClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("Print")}
            </Button>
          </div>
        ),
      },
    },
  ];

  function transactionsListRefresh() {
    loadData();
  }

  var biRef = {};

  function refreshData() {
    loadData();
  }

  function closeWindow(flag) {
    setSelectedJournal(null);
    setShowCrud(flag);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {translate("Journal Entry List")}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{
                      marginLeft: 15,
                      position: "relative",
                      top: 4,
                    }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      {showCrud && (
        <JournalEntryCrud
          mode={mode}
          setmode={setMode}
          selectedJournal={selectedJournal}
          refreshData={refreshData}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
          setOpenWindow={closeWindow}
          viewOnlyForUpdate={viewOnlyForUpdate}
        ></JournalEntryCrud>
      )}
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
      ></GenericReportViewer>
    </Grid>
  );
}
